import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'normalize.css';
import configureStore from './redux';
import Header from './components/header/header';
import Routes from './routes/';
import { setLocale, setTranslations } from 'react-i18nify';
import { getClientLanguage } from './util/i18n';
import translations from './i18n';

// Import stylesheets
import './assets/stylesheets/base.scss';

// Dynamically set title and favicon
if (typeof document !== 'undefined') {
  document.title = 'HealthWeek';
  let link = document.querySelector("link[rel*='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.type = 'image/gif';
  link.href = 'https://i.pinimg.com/originals/d5/96/3c/d5963c6f0bc206e3723f796e3b54fd6b.gif';
}

const store = configureStore();

setTranslations(translations);
setLocale(getClientLanguage() || 'en');

ReactDOM.render((
  <Provider store={store}>
    <BrowserRouter>
      <div className="app-container">
        <Header />
        <main>
          <Routes />
        </main>
      </div>
    </BrowserRouter>
  </Provider>
), document.getElementById('root'));

// Enable hot relading
module.hot.accept();
